import { Typography } from "@mui/material";
import React from "react";

export default function IsValidPhone() {
  return (
    <Typography
      sx={{
        color: "success.main",
      }}
    >
      شماره ملی با شماره موبایل مطابقت دارد.
    </Typography>
  );
}
